import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1d4e0157"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "member-rights"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/psychology-app/member-rights.png"
}, null, -1));
const _hoisted_3 = {
  class: "member-rights-info"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "member-rights-info-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/psychology-app/member-rights-catalog.png"
})], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/psychology-app/member-rights-month-vip.png"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/psychology-app/member-rights-vip.png"
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/psychology-app/member-rights-super-vip.png"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'member-rights',
  setup(__props) {
    var currentSelectedIndex = ref(2);
    function changeCurrentSelectedIndex(index) {
      currentSelectedIndex.value = index;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
        class: _normalizeClass(["member-rights-info-item", {
          'member-rights-info-item-active': _unref(currentSelectedIndex) == 1
        }]),
        onClick: _cache[0] || (_cache[0] = $event => changeCurrentSelectedIndex(1))
      }, _hoisted_6, 2), _createElementVNode("div", {
        class: _normalizeClass(["member-rights-info-item", {
          'member-rights-info-item-active': _unref(currentSelectedIndex) == 2
        }]),
        onClick: _cache[1] || (_cache[1] = $event => changeCurrentSelectedIndex(2))
      }, _hoisted_8, 2), _createElementVNode("div", {
        class: _normalizeClass(["member-rights-info-item", {
          'member-rights-info-item-active': _unref(currentSelectedIndex) == 3
        }]),
        onClick: _cache[2] || (_cache[2] = $event => changeCurrentSelectedIndex(3))
      }, _hoisted_10, 2)])]);
    };
  }
});